/* reformulacion de nuevas rutas */
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@material-tailwind/react';
import { LanguageProvider } from './components/context/LanguageContext'; // Importa el LanguageProvider
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './components/layout/Home';
import Hacemos from './components/pages/Hacemos';
import Noticias from './components/noticias/Noticias';
import Geoportal from './components/mapas/Geoportal';
import NoticiaDetalle from './components/noticias/NoticiasDetalle';
import Contactos from './components/pages/Contactos'; // Importa el componente Contactos
import LoadingScreen from './components/ui/LoadingScreen';

import CookieBanner from './components/ui/CookieBanner'; // Importa el componente CookieBanner
import './App.css';





const App = () => {
  console.log("✅ThemeProvider está envolviendo la app");

  const [loading, setLoading] = useState(true); // Estado para controlar la pantalla de carga

  // Simular una carga antes de mostrar la aplicación
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 4000); // Simula una pantalla de carga de 4 segundos -reduir o eliminar esto si no  es necesario 
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider> {/* Envuelve tu aplicación con ThemeProvider */}
      <LanguageProvider> {/* Envuelve tu aplicación con LanguageProvider */}
        <Router>
          {loading ? (
            <LoadingScreen />
          ) : (
            <>
              <Navbar />
              <main className="mt-20">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/noticias" element={<Noticias />} />
                  <Route path="/inicio" element={<Home />} />
                  <Route path="/que-hacemos" element={<Hacemos />} />
                  <Route path="/geoportal" element={<Geoportal />} />
                  <Route path="/noticia/:noticiaId" element={<NoticiaDetalle />} />
                  <Route path="/contactos" element={<Contactos />} />
                  <Route path="*" element={<Home />} />
                </Routes>
                <CookieBanner />
                {/* Agregar SpeedInsights en un lugar específico de la interfaz */}
              </main>
              <Footer />
            </>
          )}
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
